import './thetownkitchen/style';
import FormStructure from './thetownkitchen/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js